module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step5_Image5.9e510a1f.jpg";